import { registerWidget, type CellContentProps } from '../registry'

/** E9 · json content — compact mono; the Cell truncates inline and expands the full value. */
function JsonContent({ value }: CellContentProps) {
  if (value == null || value === '') {
    return <span className="text-muted-foreground">—</span>
  }
  let text: string
  try {
    text = typeof value === 'string' ? value : JSON.stringify(value)
  } catch {
    text = String(value)
  }
  return <span className="font-mono text-xs text-muted-foreground">{text}</span>
}

registerWidget('json', { read: JsonContent, defaultWidth: 240 })
